import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Tooltip } from 'lib/cortiUI';
export const FailedAiScoreIndicator = () => {
    const { t } = useTranslation('missionControlApp', { keyPrefix: 'callsDataGrid' });
    return (React.createElement(Tooltip, { title: t('failedAiScoreTooltip', 'Could not load data') },
        React.createElement(ErrorRoundedIcon, { fontSize: "small", color: "action" })));
};
